import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { IOffersState } from './offers.reducer';
import * as fromReducer from './offers.reducer';

const getOffersState = createFeatureSelector<IOffersState>('offers');

export const getOffers = createSelector(getOffersState, fromReducer.getOffers);
export const hasNextPageOffers = createSelector(getOffersState, fromReducer.hasNextPage);
export const getLatestOffers = createSelector(getOffersState, fromReducer.getLatestOffers);
export const getOffersActionState = createSelector(
  getOffersState,
  fromReducer.getOffersActionState
);
export const getOffer = createSelector(getOffersState, fromReducer.getOffer);
export const getOfferActionState = createSelector(getOffersState, fromReducer.getOfferActionState);
export const getOffersPageInfo = createSelector(getOffersState, fromReducer.getOffersPageInfo);
